(() => {
  const SECTION = 'abm-cart-drawer';
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const drawer = () => document.querySelector('[data-abm-cart-drawer]');
  let lastFocus = null;

  const focusables = (el) => [...el.querySelectorAll('a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])')].filter((n) => n.offsetParent !== null);

  function open() {
    const el = drawer();
    if (!el || el.hasAttribute('data-disabled')) return false;
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('abm-cd-lock');
    requestAnimationFrame(() => (el.querySelector('.abm-cd__close') || el.querySelector('.abm-cd__panel')).focus({ preventScroll: true }));
    return true;
  }

  function close() {
    const el = drawer();
    if (!el || !el.classList.contains('is-open')) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('abm-cd-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  function updateBadges(count) {
    document.querySelectorAll('[data-abm-cart-link]').forEach((link) => {
      let badge = link.querySelector('.abm-cart-count');
      if (count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'abm-cart-count';
          link.appendChild(badge);
        }
        badge.textContent = count;
      } else if (badge) {
        badge.remove();
      }
    });
  }

  function render(html) {
    const el = drawer();
    if (!el || !html) return;
    const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-abm-cart-inner]');
    const current = el.querySelector('[data-abm-cart-inner]');
    if (!fresh || !current) return;
    current.replaceWith(fresh);
    updateBadges(Number(fresh.dataset.count || 0));
  }

  function showError(message) {
    const box = drawer() && drawer().querySelector('[data-abm-cart-error]');
    if (!box) return;
    box.textContent = message;
    box.hidden = false;
  }

  async function request(url, body) {
    const el = drawer();
    el && el.classList.add('is-busy');
    try {
      const response = await fetch(url, { method: 'POST', headers: { Accept: 'application/json', ...(body instanceof FormData ? {} : { 'Content-Type': 'application/json' }) }, body: body instanceof FormData ? body : JSON.stringify(body) });
      const data = await response.json();
      if (!response.ok || data.status) {
        const sections = await fetch(`${root}?sections=${SECTION}`).then((r) => r.json()).catch(() => null);
        if (sections) render(sections[SECTION]);
        showError(data.description || data.message || (el && el.dataset.error));
        return null;
      }
      render(data.sections && data.sections[SECTION]);
      return data;
    } catch (error) {
      showError(el && el.dataset.error);
      return null;
    } finally {
      el && el.classList.remove('is-busy');
    }
  }

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (event.defaultPrevented || !(form instanceof HTMLFormElement) || !drawer() || drawer().hasAttribute('data-disabled')) return;
    if (!/\/cart\/add/.test(form.getAttribute('action') || '')) return;
    event.preventDefault();
    const button = event.submitter || form.querySelector('[type="submit"]');
    button && button.setAttribute('aria-busy', 'true');
    button && button.setAttribute('data-abm-cart-add', '');
    const body = new FormData(form);
    body.append('sections', SECTION);
    body.append('sections_url', window.location.pathname);
    const result = await request(`${root}cart/add.js`, body);
    button && button.removeAttribute('aria-busy');
    open();
    if (result) document.dispatchEvent(new CustomEvent('abm:cart:added', { detail: result }));
  });

  document.addEventListener('click', async (event) => {
    const link = event.target.closest('[data-abm-cart-link]');
    if (link && !event.metaKey && !event.ctrlKey && open()) {
      event.preventDefault();
      return;
    }
    if (event.target.closest('[data-abm-cart-close]')) {
      close();
      return;
    }
    const qty = event.target.closest('[data-abm-cart-qty]');
    if (qty) {
      const line = Number(qty.closest('[data-line]').dataset.line);
      await request(`${root}cart/change.js`, { line, quantity: Math.max(0, Number(qty.dataset.abmCartQty)), sections: [SECTION], sections_url: window.location.pathname });
      const next = drawer().querySelector(`[data-line="${line}"] [data-abm-cart-qty]`) || drawer().querySelector('.abm-cd__close');
      next && next.focus({ preventScroll: true });
    }
  });

  document.addEventListener('keydown', (event) => {
    const el = drawer();
    if (!el || !el.classList.contains('is-open')) return;
    if (event.key === 'Escape') {
      close();
      return;
    }
    if (event.key !== 'Tab') return;
    const items = focusables(el.querySelector('.abm-cd__panel'));
    if (!items.length) return;
    const first = items[0];
    const last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    fetch(`${root}?sections=${SECTION}`).then((r) => r.json()).then((s) => render(s[SECTION])).catch(() => {});
  });

  window.AbmCartDrawer = { open, close };
})();
